// VPS product data – plan names, prices, specs are product-level content.
// Translatable content (titles, taglines, features) uses tPrefix to look up i18n keys.

export const VPS_TYPES = [
  {
    slug: 'storage',
    tPrefix: 'storage',
    badgeKey: null,
    fromPrice: '7.00',
    penguinImage: '/images/penguin/penguin_eat_hdd.svg',
    penguinAlt: 'Storage VPS Mascot',
    numFeatures: 6,
    plans: [
      {
        name: 'Cloud-Speicher Starter',
        price: '7.00',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=319',
        specs: [
          { labelKey: 'cpu',     value: '2 vCores' },
          { labelKey: 'ram',     value: '1 GB' },
          { labelKey: 'storage', value: '1,000 GB HDD' },
          { labelKey: 'traffic', value: '2 TB / month' },
          { labelKey: 'access',  value: 'Full Root Access' },
        ],
      },
      {
        name: 'Cloud-Speicher Small',
        price: '12.50',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=320',
        specs: [
          { labelKey: 'cpu',     value: '2 vCores' },
          { labelKey: 'ram',     value: '2 GB' },
          { labelKey: 'storage', value: '2,000 GB HDD' },
          { labelKey: 'traffic', value: '4 TB / month' },
          { labelKey: 'access',  value: 'Full Root Access' },
        ],
      },
      {
        name: 'Cloud-Speicher Medium',
        price: '20.00',
        popular: true,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=321',
        specs: [
          { labelKey: 'cpu',     value: '2 vCores' },
          { labelKey: 'ram',     value: '2 GB' },
          { labelKey: 'storage', value: '3,000 GB HDD' },
          { labelKey: 'traffic', value: '6 TB / month' },
          { labelKey: 'access',  value: 'Full Root Access' },
        ],
      },
      {
        name: 'Cloud-Speicher Large',
        price: '27.00',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=322',
        specs: [
          { labelKey: 'cpu',     value: '2 vCores' },
          { labelKey: 'ram',     value: '4 GB' },
          { labelKey: 'storage', value: '5,000 GB HDD' },
          { labelKey: 'traffic', value: '10 TB / month' },
          { labelKey: 'access',  value: 'Full Root Access' },
        ],
      },
    ],
  },
  {
    slug: 'kvm-ryzen',
    tPrefix: 'ryzen',
    badgeKey: 'badge_fastest',
    fromPrice: '2.35',
    penguinImage: '/images/penguin/pingurack.png',
    penguinAlt: 'KVM Ryzen VPS Mascot',
    numFeatures: 6,
    plans: [
      {
        name: 'KVM Game Ryzen S',
        price: '2.35',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=641',
        specs: [
          { labelKey: 'cpu',     value: '1 AMD Ryzen vCore 3.7GHz+' },
          { labelKey: 'model',   value: 'Ryzen 7900/8700G' },
          { labelKey: 'ram',     value: '2 GB' },
          { labelKey: 'storage', value: '25 GB NVMe SSD' },
          { labelKey: 'traffic', value: '5 TB FairUse' },
        ],
      },
      {
        name: 'KVM Game Ryzen M',
        price: '4.95',
        popular: true,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=639',
        specs: [
          { labelKey: 'cpu',     value: '2 AMD Ryzen vCores 3.7GHz+' },
          { labelKey: 'model',   value: 'Ryzen 7900/8700G' },
          { labelKey: 'ram',     value: 'from 6 GB' },
          { labelKey: 'storage', value: 'from 50 GB NVMe SSD' },
          { labelKey: 'traffic', value: '15 TB FairUse' },
        ],
      },
      {
        name: 'KVM Game Ryzen XL',
        price: '19.95',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=642',
        specs: [
          { labelKey: 'cpu',     value: '6 AMD Ryzen vCores 3.7GHz+' },
          { labelKey: 'model',   value: 'Ryzen 7900/8700G' },
          { labelKey: 'ram',     value: 'from 24 GB' },
          { labelKey: 'storage', value: 'from 200 GB NVMe SSD' },
          { labelKey: 'traffic', value: '40 TB FairUse' },
        ],
      },
    ],
  },
  {
    slug: 'kvm',
    tPrefix: 'kvm',
    badgeKey: null,
    fromPrice: '1.00',
    penguinImage: '/images/penguin/penguin_hug_server.svg',
    penguinAlt: 'KVM VPS Mascot',
    numFeatures: 6,
    plans: [
      {
        name: 'KVM vServer FLEX',
        price: '1.00',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=580',
        specs: [
          { labelKey: 'cpu',     value: '1 vCore' },
          { labelKey: 'ram',     value: '1 GB DDR3/4 ECC' },
          { labelKey: 'storage', value: '10 GB NVMe' },
          { labelKey: 'traffic', value: '250 GB FairUse' },
          { labelKey: 'network', value: '100 Mbit/s · 1 IPv6' },
        ],
      },
      {
        name: 'KVM VPS SSD',
        price: '3.00',
        popular: true,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=582',
        specs: [
          { labelKey: 'cpu',     value: 'up to 8 Xeon vCores' },
          { labelKey: 'ram',     value: 'up to 32 GB DDR3/4 ECC' },
          { labelKey: 'storage', value: 'up to 250 GB SSD' },
          { labelKey: 'traffic', value: '2 TB FairUse' },
          { labelKey: 'network', value: '1 Gbit/s · IPv6 incl.' },
        ],
      },
    ],
  },
  {
    slug: 'windows',
    tPrefix: 'windows',
    badgeKey: 'badge_windows',
    fromPrice: '6.65',
    penguinImage: '/images/penguin/penguin_eat_windows.svg',
    penguinAlt: 'Windows VPS Mascot',
    numFeatures: 6,
    plans: [
      {
        name: 'Windows VPS Starter',
        price: '6.65',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=600',
        specs: [
          { labelKey: 'cpu',     value: '2 vCores' },
          { labelKey: 'ram',     value: '2 GB' },
          { labelKey: 'storage', value: '250 GB NVMe' },
          { labelKey: 'traffic', value: 'Unlimited FairUse' },
          { labelKey: 'os',      value: 'Server 2012/2016/2019' },
        ],
      },
      {
        name: 'Windows VPS Medium',
        price: '7.65',
        popular: true,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=601',
        specs: [
          { labelKey: 'cpu',     value: '3 vCores' },
          { labelKey: 'ram',     value: '3 GB' },
          { labelKey: 'storage', value: '250 GB NVMe' },
          { labelKey: 'traffic', value: 'Unlimited FairUse' },
          { labelKey: 'os',      value: 'Server 2012/2016/2019' },
        ],
      },
      {
        name: 'Windows VPS Large',
        price: '9.95',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=602',
        specs: [
          { labelKey: 'cpu',     value: '4 vCores' },
          { labelKey: 'ram',     value: '4 GB' },
          { labelKey: 'storage', value: '250 GB NVMe' },
          { labelKey: 'traffic', value: 'Unlimited FairUse' },
          { labelKey: 'os',      value: 'Server 2012/2016/2019' },
        ],
      },
    ],
  },
];

export function getVPSBySlug(slug) {
  return VPS_TYPES.find((v) => v.slug === slug) || null;
}
